import { Dialog } from '@enuygun/design-system'
import { down, up } from 'styled-breakpoints'
import styled, { css } from 'styled-components'

export const PromotedIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 10px;
  vertical-align: middle;

  [dir='rtl'] & {
    margin-right: 0;
    margin-left: 10px;
    transform: scaleX(-1);
  }
`

export const PromotedHeading = styled.h2<{ $anniversary?: boolean }>`
  color: #131717;
  font-size: ${({ $anniversary }) => ($anniversary ? '32px' : '24px')};
  font-weight: 700;
  line-height: 33px;
  margin: 0px;
  ${down('md')} {
    font-size: ${({ $anniversary }) => ($anniversary ? '28px' : '20px')};
    font-weight: ${({ $anniversary }) => ($anniversary ? 700 : 600)};
  }
`

export const AnniversaryHighlight = styled.span`
  color: #249e3e;
`

export const PromotedSubheading = styled.p`
  color: #53605e;
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  margin: 8px 0 8px 0;
`

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`

export const ButtonWrapper = styled.div<{ $anniversary?: boolean; $mobileBlock?: boolean }>`
  flex: 1;
  display: flex;
  justify-content: flex-end;

  ${({ $anniversary }) =>
    $anniversary &&
    css`
      a,
      button {
        color: #249e3e !important;
        background-color: #ffffff !important;

        &:hover {
          background-color: #eafaee !important;
          color: #006e00 !important;
        }
      }
    `}

  ${({ $mobileBlock }) =>
    $mobileBlock &&
    css`
      flex: none;
      width: 100%;
      margin-top: 16px;
      justify-content: stretch;

      a,
      button {
        width: 100%;
      }
    `}
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  ${down('md')} {
    width: 100%;
    flex-wrap: wrap;
  }
`

export const HeaderTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
`

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  gap: 4px;
  position: relative;
  z-index: 3;
`

export const PromotedFlightWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  .splide__slide {
    display: flex;
    height: auto;
  }

  .splide__slide > div {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  ${down('md')} {
    margin-bottom: 16px;
    .splide__track {
      overflow: hidden;
    }
  }

  /* RTL support - sadece kart içerikleri için */
  div[dir='rtl'] {
    direction: rtl;

    /* Kart içeriğinin RTL düzenini sağla */
    article,
    [class*='PromotedFlightCard'],
    a[data-testid^='featured-flight-'] {
      direction: rtl;
    }

    /* Footer: fiyat üstte, son güncelleme altta (yalnızca RTL) */
    article > div:last-child,
    [class*='PromotedFlightCard'] > div:last-child,
    a[data-testid^='featured-flight-'] > div:last-child {
      display: flex !important;
      flex-direction: column-reverse !important;
      align-items: flex-start;
      gap: 4px;
      text-align: right;
      width: 100%;
    }
  }
`
export const HeaderContainer = styled.div`
  align-items: baseline;
  gap: 24px;
  display: flex;
  margin: 0px;
  width: 100%;

  ${down('md')} {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    position: relative;
    width: 100%;
  }
`

export const ConfettiLayer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
  contain: paint;
  transform: translateZ(0);
`

/** Figma Group 1 — desktop tüm glow */
export const DesktopGlow = styled.div`
  display: none;
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  [dir='rtl'] &,
  &:dir(rtl) {
    svg {
      transform: scaleX(-1);
    }
  }

  ${up('md')} {
    display: block;
  }
`

/** Figma Ellipse 8 (1) — mobile tüm glow */
export const MobileGlow = styled.div`
  display: none;
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  [dir='rtl'] &,
  &:dir(rtl) {
    svg {
      transform: scaleX(-1);
    }
  }

  ${down('md')} {
    display: block;
  }
`

export const Foreground = styled.div`
  position: relative;
  z-index: 1;
  isolation: isolate;
  transform: translateZ(0);
`

export const Wrapper = styled.div<{ isChristmasActive?: boolean; $withConfetti?: boolean }>`
  margin: 40px 0px;
  position: relative;
  overflow: visible;

  ${({ $withConfetti }) =>
    $withConfetti &&
    css`
      isolation: isolate;
      overflow: hidden;
      border: 1px solid #9966ff;
      border-radius: 16px;
      padding: 28px 24px 24px;
      box-shadow: 0px 2px 10px rgba(32, 43, 55, 0.12);
      background: #ffffff;

      ${down('md')} {
        padding: 28px 16px 24px;
      }

      ${PromotedFlightWrapper} {
        position: relative;
        z-index: 1;

        .splide,
        .splide__track,
        .splide__list,
        .splide__slide {
          position: relative;
          z-index: 1;
        }

        .splide__arrow {
          z-index: 5;
        }

        .splide__slide > div,
        .splide__slide > * {
          position: relative;
          z-index: 1;
          isolation: isolate;
          transform: translateZ(0);
        }

        /* Kart ve şeffaf footer confetti'nin üstünde kalsın */
        a[data-testid^='featured-flight-'] {
          background-color: #fff;
          position: relative;
          z-index: 2;
          isolation: isolate;
        }

        a[data-testid^='featured-flight-'] > div:last-child {
          background-color: #fff;
          position: relative;
          z-index: 2;
        }
      }
    `}

  ${down('md')} {
    margin-bottom: 32px;

    ${(props) =>
      props.isChristmasActive &&
      `
      position: relative;
      background-image: url('https://cdn2.enuygun.com/media/lib/uploads/image/mb-bg-promoted-69578.jpeg');
      background-size: 100% auto;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 0;
      padding: 20px 16px;
      margin: 20px -16px;
      width: calc(100% + 32px);
      min-height: 439px;
      
      ${InfoSpan} {
        background: transparent;
        padding: 8px 12px;
        border-radius: 8px;
        backdrop-filter: blur(8px);
      }
      
      .endesign-tooltip-content,
      .endesign-bottomsheet-content {
        background: rgba(255, 255, 255, 0.95) !important;
        backdrop-filter: blur(10px);
      }
      
      /* PromotedFlightCard footer background - fiyat ve zaman bölümü */
      article > div:last-child,
      [class*="PromotedFlightCard"] > div:last-child,
      [data-testid*="promoted-flight-card"] > div > div:last-child {
        background-color: #F8FAF9 !important;
        border-radius: 12px !important;
      }
      
    `}
  }
`

export const InfoSpan = styled.span`
  font-size: 12px;
  color: #000;
  position: relative;
  z-index: 99;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  justify-content: flex-start;
  ${down('md')} {
    margin-top: 5%;
  }

  &[dir='rtl'] {
    direction: rtl;
    text-align: right;
    unicode-bidi: isolate;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
`

export const TabsButton = styled.div<{ active: boolean; isChristmas?: boolean }>`
  border: ${(props) => (props.active ? '1px solid #131717;' : 'none')};
  display: flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  /* margin-right: 32px; */
  background-color: transparent;
  border-radius: 200px;
  cursor: pointer;
  color: #131717;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  z-index: 1;
  font-weight: ${(props) => (props.active ? '600' : '400')};
  line-height: normal;
  white-space: nowrap;

  ${(props) =>
    props.isChristmas &&
    `
    width: auto;
    min-width: 145px;
    height: 39px;
    position: relative;
    padding: 10px 16px;
    background: linear-gradient(180deg, #FF757A 0%, #FFEBEC 100%);
    border: none;
    border-radius: 200px;
    color: #131717;
    font-size: 14px;
    line-height: 35px;
    overflow: visible;
    
    &::before {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      right: 2px;
      bottom: 2px;
      background: #fff;
      border-radius: 198px;
      z-index: -1;
    }
    
    
    &::after {
      content: '';
      position: absolute;
      top: -20px;
      right: -12px;
      width: 40px;
      height: 40px;
      background-image: url('https://cdn2.enuygun.com/media/lib/uploads/image/button-bg-border-69574.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 4;
      pointer-events: none;
    }
    
    & > * {
      position: relative;
      z-index: 3;
      padding: 0 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    
    @media (max-width: 768px) {
      display: inline-flex !important;
      min-width: 160px;
      max-width: 200px;
      flex-shrink: 0;
      white-space: nowrap;
      width: auto;
      font-weight: 700;
      background: transparent !important;
      border: 1px solid #FF757A; !important;
      color: #131717;
      padding: 10px 16px !important;
      
      &::before {
        display: none !important;
      }
      
      & > * {
        padding: 0 !important;
      }
      
      &::after {
        top: -15px;
        right: -8px;
        width: 35px;
        height: 35px;
      }
      
    }
  `}

  ${down('md')} {
    display: inline-flex;
    height: 39px;
    flex-shrink: 0;
    white-space: nowrap;
    min-width: fit-content;
    width: auto;
  }
`
export const TabsContainer = styled.div`
  display: flex;
  gap: 12px;
  position: relative;
  flex-wrap: nowrap;

  ${down('md')} {
    display: flex;
    flex-direction: row;
    width: 100%;
    overflow-x: auto;
    overflow-y: visible;
    flex-wrap: nowrap !important;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 20px 0 5px 0;
    margin: -20px 0 -5px 0;
    gap: 8px;
    align-items: center;

    &::-webkit-scrollbar {
      display: none;
    }

    [dir='rtl'] & {
      padding-right: 0px;
    }
  }
`

export const TabsRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
  position: relative;
  z-index: 3;

  ${ButtonWrapper} {
    flex: 0 0 auto;
    margin-inline-start: auto;
  }

  &[dir='rtl'] ${ButtonWrapper} {
    margin-left: 0;
    margin-right: auto;
  }

  ${down('md')} {
    flex-direction: column;
    align-items: stretch;

    ${ButtonWrapper} {
      margin-inline-start: 0;
      margin-right: 0;
    }
  }
`
export const StyledList = styled.ul`
  list-style-type: disc;
  padding-left: 20px;

  [dir='rtl'] & {
    padding-left: 0;
    padding-right: 20px;
  }
`

export const StyledListItem = styled.li`
  margin-bottom: 10px;
  white-space: wrap;
  ::marker {
    color: black; /* Customize the color of the filled dot if needed */
  }
`

export const Modal = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  ${down('md')} {
    display: block;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8px;
    z-index: 11;
    font-size: 14px;
  }
`

export const ModalContent = styled.div`
  background-color: white;
  width: 100%;
  border-radius: 10px;
  [dir='rtl'] & {
    left: 0;
  }
  ${down('md')} {
    width: 100%;
    bottom: 0;
    height: 60%;
  }
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #131717;
`

export const ModalClose = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #131717;
  cursor: pointer;
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const InfoButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`

export const SeeAllLink = styled.a<{ $anniversary?: boolean }>`
  color: ${({ $anniversary }) => ($anniversary ? '#249E3E' : '#0087ff')};
  text-decoration: none;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  padding: 0 8px;
  height: 39px;
  ${({ $anniversary }) =>
    $anniversary &&
    css`
      background-color: #ffffff;
      border-radius: 8px;
      padding: 0 12px;
    `}
`
